import { formatPostalAddress } from '@klareospace/pharos-lib-utils';

// ─── Types ────────────────────────────────────────────────────────────────────

interface SuggestionAddress {
  city?: string;
  countryName?: string;
  houseNumber?: string;
  postalCode?: string;
  street?: string;
}

// ─── Utils ────────────────────────────────────────────────────────────────────

/**
 * Formats a suggestion address for display in the search dropdown.
 * Maps countryName (provider human-readable name) to the country slot of
 * formatPostalAddress so the displayed format matches the stored originalAddress.
 */
export function formatSuggestionAddress(address?: SuggestionAddress): string {
  if (!address) return '';
  return formatPostalAddress({
    city: address.city,
    country: address.countryName,
    houseNumber: address.houseNumber,
    postalCode: address.postalCode,
    street: address.street,
  });
}
